import React, { Fragment, useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { routes } from './Routes';
import AppLayout from '../SuperAdmin/Layout/Layout';
import ComingsoonVideo from '../Components/Pages/ComingSoon/ComingBgVideo';
// import AppLayout from '../Layout/Layout';

const LayoutRoutes = () => {
  const location = useLocation();
  const navigation = useNavigate();
  const pathName = location.pathname;
  console.log(pathName)

  const checkIfRouteExistsOrNot = () => {
    const res = routes.some(route => route.path === pathName);
    if (!res) {
      navigation("/maintenance")
    }
  }

  useEffect(() => {
    checkIfRouteExistsOrNot();
  }, [])

  return (
    <>
      <Routes>
        {routes.map(({ path, Component }, i) => (
          <Fragment key={i}>
            <Route element={<AppLayout />} key={i}>
              {
                routes.some(route => route.path === pathName) ?
                  <Route path={`${path}`} element={Component} /> :
                  <Route path={`/maintenance`} element={ComingsoonVideo} />
              }
            </Route>
          </Fragment>
        ))}
      </Routes>
    </>
  );
};

export default LayoutRoutes;